export const ROUTE_MAX_WIDTH_CLASS =
  "mx-auto w-full max-w-(--route-max-width,64rem)";

export const ROUTE_GUTTER_CLASS = "px-4 md:px-4";

export const ROUTE_COLUMN_CLASS = `${ROUTE_MAX_WIDTH_CLASS} ${ROUTE_GUTTER_CLASS}`;

export const ROUTE_HEADER_SHELL_CLASS = `${ROUTE_MAX_WIDTH_CLASS} ${ROUTE_GUTTER_CLASS}`;
